import { getElementDefinitionProps } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import _ from 'lodash';
import { elementTypes } from 'crazyEditor/components/Elements/index';
import { addIsTextElementIndication } from '../shared/sharedDataFixer';
import { PADDING_PROP_NAMES } from 'crazyEditor/core/constants/panelConstants';
import update from 'react-addons-update';
import { zIndexMouseCatcher } from 'crazyEditor/core/globals';
import { cLencodeURIcomponent } from 'MyAccount/ViewDesigns/helpers/resizeImageUrlHelper';

/*
 Add cross sell gallery data
 */
function addCrossSellGalleryData(element) {
  if (_.isEmpty(window.___data)) {
    return;
  }
  if (element.type === elementTypes.CrossSellGalleryElement) {
    if (_.isUndefined(element.data.sellerId)) {
      const firstSeller = _.find(window.___data.accountPage.accounts, {first: true});
      if (firstSeller) {
        element.data.sellerId = firstSeller.UserID;
      }
    }
    if (_.isUndefined(element.data.globalId)) {
      element.data.globalId = 'EBAY-US';
    }
  }
}

/*
 Add gallery data
 */
function addGalleryData(element) {
  if (element.type === elementTypes.GalleryElement) {
    _.forEach(element.data.list, (listElement, index) => {
      element.data.list[index] = cLencodeURIcomponent(listElement);
    });
    if (_.isUndefined(element.data.showThumbnails)) {
      element.data.showThumbnails = true;
    }
    if (_.isUndefined(element.data.showDottedNav)) {
      element.data.showDottedNav = false;
    }
    if (_.isUndefined(element.data.alwaysShowNavArrow)) {
      element.data.alwaysShowNavArrow = false;
    }
    _.forEach(PADDING_PROP_NAMES, (propName) => {
      if (_.isUndefined(element.compProps[propName])) {
        element.compProps[propName] = 20;
      }
    });
  }
}

function removeCyclicParentChildRelationship(element) {
  const parentId = _.get(element, 'parentId');
  const children = _.get(element, 'data.children');
  if (children) {
    _.forEach(children, (child) => {
      delete child.parent;
    });
  }
  if (parentId) {
    delete element.parent;
  }
}

function removeTemplateTagSetData(element) {
  if (_.has(element, 'data.templateTagData')) {
    delete element.data.templateTagData;
  }
}

function combineChildren(elements) {
  const elementsToUpdate = {};
  const constChildrenByParentId = {};
  _.forEach(elements, (element) => {
    const parentId = element.parentId;
    if (parentId) {
      if (constChildrenByParentId[parentId]) {
        constChildrenByParentId[parentId].push(element);
      } else {
        constChildrenByParentId[parentId] = [element];
        elementsToUpdate[parentId] = {
          data: {
            children: {
              $set: constChildrenByParentId[parentId]
            }
          }
        };
      }
      delete elements[element.id];
    }
  });
  if (!_.isEmpty(elementsToUpdate)) {
    return update(elements, elementsToUpdate);
  }
  return elements;
}

function fixZIndex(elements) {
  let zIndexTooHigh = false;
  let zIndexDuplicateCount = 0;
  let lastZIndex;
  let zIndexesMap = _.map(elements, element => (_.get(element, 'compProps.zIndex', 1))).sort((a, b) => (a - b)).map((zIndex, index)=> {
    if (zIndex >= zIndexMouseCatcher) {
      zIndexTooHigh = true;
    }
    if (lastZIndex === zIndex) {
      zIndexDuplicateCount++;
      return null;
    }
    lastZIndex = zIndex;
    return {oldZIndex: zIndex, newZIndex: index + 1, used: 0};
  });
  zIndexesMap = _.keyBy(zIndexesMap, 'oldZIndex');
  if (zIndexTooHigh || zIndexDuplicateCount > 0) {
    _.forEach(elements, element => {
      const zIndexNewValueData = zIndexesMap[element.compProps.zIndex];
      if (zIndexNewValueData) {
        element.compProps.zIndex = zIndexNewValueData.newZIndex + zIndexNewValueData.used;
        zIndexNewValueData.used++;
      }
    });
  }
}

const OLD_DEFAULT_FONT_SIZE = 12;
function setOldDefaultFont(element, elementDefinitionProps, fontSize) {
  fontSize = fontSize || parseInt(_.get(element, 'data.compProps.fontSize'), 10) || parseInt(_.get(element, 'compProps.fontSize'), 10) || OLD_DEFAULT_FONT_SIZE;
  switch (element.type) {
    case elementTypes.TabsElement:
      _.forEach(element.data.children, child => {setOldDefaultFont(child, fontSize);});
      break;
    case elementTypes.RichTextElement:
      _.set(element, 'compProps.fontSize', fontSize);
      break;
    default:
      return;
  }
  _.set(element, 'data.compProps.fontSize', fontSize);
}

function fixIncorrectBackgroundImage(element) {
  if (_.isObject(_.get(element, 'compProps.backgroundImage'))) {
    delete element.compProps.backgroundImage;
  }
}

function removeProblematicLegaxyStylingProps(element) {
  if (element.compProps.borderWidth || element.compProps.borderSize || element.compProps.borderStyle) {
    delete element.compProps.border;
  }
}

function desktopDataFixer(element) {
  const elementDefinitionProps = getElementDefinitionProps(element.type);
  const fixerFn = [addIsTextElementIndication, addGalleryData, setOldDefaultFont, removeProblematicLegaxyStylingProps, removeCyclicParentChildRelationship, addCrossSellGalleryData, removeTemplateTagSetData];
  _.forEach(fixerFn, (fn) => fn.call(this, element, elementDefinitionProps));

  return element;
}

export {
  desktopDataFixer,
  combineChildren,
  fixZIndex,
  fixIncorrectBackgroundImage,
};
